import { UserProvider } from './context/UserContext.jsx';
import { ToastProvider } from './context/ToastContext.jsx';
import AppRoutes from './routes/AppRoutes.jsx';

const App = () => (
  <ToastProvider>
    <UserProvider>
      <AppRoutes />
    </UserProvider>
  </ToastProvider>
);

export default App;
